export const eventAddons = (params: { eventId: number }) => `event:${params.eventId}`;
